import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//cta-5.twig
import React from 'react';
import { Section, Box, Text, Container } from '@miro-site/core';
import { contextualSpaces, Headline, Content, LazyImageAdapter, ButtonAdapter } from '@miro-site/components_utils';
import { theme } from '@miro-site/design-tokens';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var WORKSHOPS_BG_COLORS = {
  'workshops-color-grey': theme.colors.workshopGray,
  'workshops-color-indigo': theme.colors.primaryIndigo,
  'workshops-color-blue': theme.colors.passionate,
  'workshops-color-pink': theme.colors.human,
  'workshops-color-red': theme.colors.bold,
  'workshops-color-yellow': theme.colors.outspoken
};
var highContrastBgColors = ['workshops-color-indigo', 'workshops-color-blue', 'workshops-color-red'];

var getHeadline = function getHeadline(headlineProps, background) {
  var text = typeof headlineProps.text == 'string' ? headlineProps.text.trim() : headlineProps.text;
  Object.assign(headlineProps, {
    text: text,
    size: headlineProps.size || 'mid',
    tag: headlineProps.tag || 'h2',
    color: highContrastBgColors.includes(background) ? 'white' : headlineProps.color,
    align: headlineProps.align || 'center'
  });
  return /*#__PURE__*/_jsx(Headline, _objectSpread({}, headlineProps));
};

var Cta = styled(Box).attrs({
  overflow: 'hidden',
  $py: [96, 240],
  $px: [0]
}).withConfig({
  displayName: "CtaWithPattern__Cta",
  componentId: "sc-1qo72gx-0"
})(["position:relative;overflow:hidden;", "{margin-left:auto;margin-right:auto;", "}.cta-with-pattern{&__shape-wrapper{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);", " &--large{", "}}&__shape{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);", "}&__elements{text-align:center;position:relative;z-index:3;}}"], Text, function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles({
    maxWidth: [null, 645]
  });
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.normalizeStyles({
    width: [365, 1430],
    height: [640, 1000]
  });
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.normalizeStyles({
    display: ['block']
  });
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.normalizeStyles({
    width: [365, 1430]
  });
});

var CtaWithPattern = function CtaWithPattern(_ref5) {
  var headline = _ref5.headline,
      content = _ref5.content,
      _ref5$background = _ref5.background,
      background = _ref5$background === void 0 ? 'workshops-color-indigo' : _ref5$background,
      button = _ref5.button,
      additional_button = _ref5.additional_button,
      shape = _ref5.shape,
      button_text = _ref5.button_text;
  var textColor = highContrastBgColors.includes(background) ? 'white' : background == 'workshops-color-grey' ? 'dark' : null;
  return /*#__PURE__*/_jsx(Section, {
    type: "large",
    "data-place": "CTA Section",
    style: {
      paddingBottom: 0
    },
    $styles: {
      textAlign: 'center'
    },
    children: /*#__PURE__*/_jsxs(Cta, {
      $styles: {
        backgroundColor: WORKSHOPS_BG_COLORS[background]
      },
      "data-testid": "cta-with-pattern_content",
      children: [/*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs("div", {
          className: "cta-with-pattern__elements",
          children: [(headline === null || headline === void 0 ? void 0 : headline.text) && getHeadline(_objectSpread(_objectSpread({}, headline), {}, {
            size: 'mid',
            tag: 'h2'
          }), background), content && /*#__PURE__*/_jsx(Content, _objectSpread(_objectSpread({}, content), {}, {
            textProps: {
              $styles: {
                marginTop: contextualSpaces.textSpaces.afterHeadline.medium
              }
            },
            color: textColor || content.color
          })), (button || additional_button) && /*#__PURE__*/_jsxs(Box, {
            $styles: {
              marginTop: contextualSpaces.buttonSpaces.afterText.common
            },
            children: [/*#__PURE__*/_jsx(ButtonAdapter, _objectSpread(_objectSpread({}, button), {}, {
              type: background == 'workshops-color-grey' ? 'blue' : 'white'
            })), additional_button && /*#__PURE__*/_jsx(ButtonAdapter, _objectSpread(_objectSpread({
              $styles: {
                marginLeft: [theme.spaces.md, theme.spaces.sm]
              }
            }, additional_button), {}, {
              type: highContrastBgColors.includes(background) ? 'transparent-white' : 'transparent'
            }))]
          }), button_text && /*#__PURE__*/_jsx(Content, _objectSpread(_objectSpread({}, button_text), {}, {
            textProps: {
              $styles: {
                marginTop: [theme.spaces.md]
              }
            },
            size: "tiny",
            color: textColor || button_text.color
          }))]
        })
      }), shape && /*#__PURE__*/_jsx("div", {
        className: "cta-with-pattern__shape-wrapper ".concat(shape.desktop ? 'cta-with-pattern__shape-wrapper--large' : ''),
        children: /*#__PURE__*/_jsx("div", {
          className: "cta-with-pattern__shape",
          children: /*#__PURE__*/_jsx(LazyImageAdapter, {
            assets: shape
          })
        })
      })]
    })
  });
};

export default CtaWithPattern;